import { NgModule } from '@angular/core';

import { CheckoutFacade } from 'ish-core/facades/checkout.facade';
import { ShoppingFacade } from 'ish-core/facades/shopping.facade';
import { FeatureToggleModule } from 'ish-core/feature-toggle.module';

import { ExtendedCheckoutFacade } from '../facades/extended-checkout.facade';
import { ExtendedShoppingFacade } from '../facades/extended-shopping.facade';

import { LazyMiniCartSuggestionComponent } from './lazy-mini-cart-suggestion/lazy-mini-cart-suggestion.component';
import { CustomQuickorderFacade } from '../../custom-quickorder/facades/custom-quickorder.facade';
import { ExtendedQuickOrderFacade } from '../facades/extended-quick-order.facade';

@NgModule({
  imports: [FeatureToggleModule],
  providers: [
    {
      provide: ShoppingFacade,
      useClass: ExtendedShoppingFacade,
    },
    {
      provide: CheckoutFacade,
      useClass: ExtendedCheckoutFacade,
    },
    {
      provide: CustomQuickorderFacade,
      useClass: ExtendedQuickOrderFacade
    }
  ],
  declarations: [LazyMiniCartSuggestionComponent],
  exports: [LazyMiniCartSuggestionComponent],
})
export class CrossSellingPopupExportsModule {}
